import BunkeyAPI from './BunkeyAPI'



export const deleteToken = () => {

    return BunkeyAPI({
        url: `/auth/sign-out`,
        method: 'post',
    })
}